import { CrudList } from '../shared/CrudPage';
import { bankTransactionService } from '@kss/api';
import type { BankTransaction, BankTransactionCreate, BankTransactionFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';
import { NameCell } from '../../hooks/useNameMaps';

export default function AllBankTransactions() {
  return (
    <CrudList<BankTransaction, BankTransactionCreate, BankTransactionFilter>
      title="All bank transactions" newLabel="New transaction" service={bankTransactionService}
      idKey="bankTransactionId" labelKey="referenceNumber" basePath="/panel/bank-transactions"
      // Newest txn on top — order-like grid. Ref: ORDER_WORKFLOW_AUDIT #6.
      initialSortStatus={{ columnAccessor: 'txnDate', direction: 'desc' }}
      columns={[
        // Live API columns (verified): txnDate, type, amount,
        // referenceNumber, description, bankAccountId, isReconciled.
        // Legacy `transactionDate` / `reference` / `accountId` keys
        // never resolved on live rows so the cells rendered '—'.
        {
          accessor: 'txnDate',
          title: 'Date',
          sortable: true,
          render: (r) => {
            const d = (r as BankTransaction & { txnDate?: string; transactionDate?: string }).txnDate
              ?? (r as BankTransaction & { transactionDate?: string }).transactionDate;
            return d ? new Date(d).toLocaleDateString() : '—';
          },
        },
        { accessor: 'type', title: 'Type', sortable: true, filterable: true, render: (r) => r.type || '—' },
        {
          accessor: 'referenceNumber',
          title: 'Reference',
          sortable: true,
          filterable: true,
          render: (r) => {
            const r2 = r as BankTransaction & { referenceNumber?: string; reference?: string };
            return r2.referenceNumber || r2.reference || '—';
          },
        },
        {
          accessor: 'description',
          title: 'Description',
          render: (r) => (r as BankTransaction & { description?: string }).description || '—',
        },
        { accessor: 'amount', title: 'Amount (₹)', sortable: true, textAlign: 'right', render: (r) => Number(r.amount ?? 0).toLocaleString('en-IN') },
        {
          accessor: 'bankAccountId',
          title: 'Account',
          render: (r) => (
            <NameCell
              kind="account"
              id={
                (r as BankTransaction & { bankAccountId?: string; accountId?: string }).bankAccountId ??
                (r as BankTransaction & { accountId?: string }).accountId
              }
            />
          ),
        },
        { accessor: 'isReconciled', title: 'Reconciled', sortable: true, render: (r) => <StatusBadge status={r.isReconciled ? 'active' : 'pending'} /> },
      ]}
    />
  );
}
